import type { FormControl } from '@angular/forms';

import { isEmpty } from '@core/utils-legacy';

const DOMAIN_PATTERN =
  /^(?!:\/\/)([a-zA-Z0-9-]+\.){0,5}[\-]?[a-zA-Z0-9-][a-zA-Z0-9-]+\.[a-zA-Z]{2,64}?$/;

const DOMAIN_PATTERN_ALTERNATIVE =
  /^(?=.{1,253}$)(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+(?:[A-Za-z]{2,12})$/;

export function domainValidator(
  control: FormControl<string | null>,
): { domainPattern: boolean } | null {
  return isEmpty(control.value) || DOMAIN_PATTERN.test(control.value)
    ? null
    : { domainPattern: true };
}

// this is more aligned with backend validation, but not quite the same, because original backend validation causes
// catastrophic backtracking:
// /^[a-zA-Z0-9]+(([\-]?[a-zA-Z0-9]+){0,61}\.)+[a-zA-Z]{2,}$/u
export function domainValidatorAlternative(
  control: FormControl<string | null>,
): { domainPattern: boolean } | null {
  return isEmpty(control.value) || DOMAIN_PATTERN_ALTERNATIVE.test(control.value)
    ? null
    : { domainPattern: true };
}
